const pageTitle = {
  Shopback: 'SHOPBACK',
  Apps: '應用程式',
  'App Store': '應用程式商店',
};

export default pageTitle;
